import { Input } from '@podiumhq/design-system';

import { FormElementSelect } from './FormElementSelect';
import { FormFieldWrapper } from './FormFieldWrapper';

export const FormElementField = ({
  displayErrorIcon = true,
  error,
  label,
  selectList,
  variant = 'basic',
  ...props
}) => {
  const { onBlur, onChange, ...wrapperProps } = props;
  const { iconProps, ...inputProps } = props;
  return (
    <FormFieldWrapper
      displayErrorIcon={displayErrorIcon}
      error={error}
      label={label}
      {...wrapperProps}
    >
      {selectList ? (
        <FormElementSelect
          isInvalid={!!error}
          selectList={selectList}
          variant={variant}
          {...inputProps}
        />
      ) : (
        <Input isInvalid={!!error} variant={variant} {...inputProps} />
      )}
    </FormFieldWrapper>
  );
};
